var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportFilterSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.535,
    height: 14.535,
    viewBox: "0 0 14.535 14.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71109",
    "data-name": "Path 71109",
    d: "M17.191,15.346A1.846,1.846,0,1,1,15.346,13.5,1.846,1.846,0,0,1,17.191,15.346Z",
    transform: "translate(-7.078 -7.078)",
    fill: "none",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71110",
    "data-name": "Path 71110",
    d: "M12.82,10.113a1.015,1.015,0,0,0,.2,1.12l.037.037a1.231,1.231,0,1,1-1.741,1.741l-.037-.037a1.023,1.023,0,0,0-1.735.726v.1a1.23,1.23,0,0,1-2.461,0v-.055A1.065,1.065,0,0,0,5.3,13.023l-.037.037a1.231,1.231,0,1,1-1.741-1.741l.037-.037a1.023,1.023,0,0,0-.726-1.735h-.1a1.23,1.23,0,1,1,0-2.461h.055A1.065,1.065,0,0,0,3.512,5.3l-.037-.037A1.231,1.231,0,1,1,5.216,3.524l.037.037a1.015,1.015,0,0,0,1.12.2h.049a1.015,1.015,0,0,0,.615-.929v-.1a1.23,1.23,0,0,1,2.461,0v.055a1.023,1.023,0,0,0,1.735.726l.037-.037a1.231,1.231,0,1,1,1.741,1.741l-.037.037a1.015,1.015,0,0,0-.2,1.12v.049a1.015,1.015,0,0,0,.929.615h.1a1.23,1.23,0,0,1,0,2.461h-.055a1.015,1.015,0,0,0-.929.615Z",
    fill: "none",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportFilterSetting);
export default __webpack_public_path__ + "static/media/icon-report-filter-setting.ad468d8f.svg";
export { ForwardRef as ReactComponent };